import React from "react";
import ReactDOM from "react-dom";

import "./styles/index.scss";
import JupyterFlex from "./App";

ReactDOM.render(<JupyterFlex />, document.getElementById("jupyter-flex-root"));
